"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_1 = require("@/client/directives/i18n");
const vue3_compat_1 = require("@/client/vue3-compat");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'PurgeWarning',
    props: {
        expectedPurgeTimeMs: {
            type: Number,
            required: true,
        },
    },
    computed: {
        hoursLeft() {
            const nowMs = Date.now();
            const diffMs = this.expectedPurgeTimeMs - nowMs;
            const diffh = diffMs / 3_600_000;
            return diffh;
        },
        translateTextWithParams() {
            return i18n_1.translateTextWithParams;
        },
    },
});
